import { Component, computed, inject, input, linkedSignal, output, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  SimpleDialogLayout,
  InputLabel,
  InputSimple,
  Select,
  Button,
  InputError,
} from 'excellence-ui';
import { FileResponse, HttpError } from '../../../../core/clients/omni-core/models';
import { form, FormField, required } from '@angular/forms/signals';
import { FieldErrors } from '../../../../shared/components/field-errors/field-errors';
import { DocumentsStore, DocumentUpdateChanges } from '../../stores/documents.store';

@Component({
  selector: 'app-document-edit-dialog',
  imports: [
    SimpleDialogLayout,
    InputLabel,
    InputSimple,
    Select,
    Button,
    TranslocoPipe,
    FormField,
    FieldErrors,
    InputError,
  ],
  templateUrl: './document-edit-dialog.html',
})
export class DocumentEditDialog {
  private store = inject(DocumentsStore);

  document = input.required<FileResponse>();

  clickCancel = output();
  updateSuccess = output<DocumentUpdateChanges>();

  private model = linkedSignal(this.document);

  protected form = form(this.model, (schemaPath) => {
    required(schemaPath.filename);
    required(schemaPath.fileType);
  });

  protected isSubmitDisabled = computed(() => {
    return (
      this.isEditLoading() ||
      !this.form().valid() ||
      (this.model().filename === this.document().filename &&
        this.model().fileType === this.document().fileType)
    );
  });

  protected isEditLoading = signal(false);
  protected editError = signal<HttpError | unknown | null>(null);

  protected async onSubmit() {
    if (this.form().invalid()) {
      this.form.filename().markAsTouched();
      this.form.fileType().markAsTouched();
      return;
    }

    this.isEditLoading.set(true);
    this.editError.set(null);

    try {
      const changes = await this.store.update(this.document().id, {
        filename: this.form.filename().value(),
        fileType: this.form.fileType().value(),
      });
      this.updateSuccess.emit(changes);
    } catch (e) {
      this.editError.set(e);
    } finally {
      this.isEditLoading.set(false);
    }
  }
}
